/**
 * Default test data service for lab test autocomplete functionality
 * Provides predefined test data with units and reference ranges
 */

export const defaultTestData = {
  "Glucose": {
    units: "mg/dL",
    lab_low: 65.0,
    lab_high: 99.0
  },
  "Uric Acid": {
    units: "mg/dL",
    lab_low: 3.8,
    lab_high: 8.4
  },
  "BUN": {
    units: "mg/dL",
    lab_low: 6.0,
    lab_high: 20.0
  },
  "Creatinine": {
    units: "mg/dL",
    lab_low: 0.76,
    lab_high: 1.27
  },
  "eGFR": {
    units: "mL/min/1.73",
    lab_low: 59.0,
    lab_high: null
  },
  "BUN/Creatinine Ratio": {
    units: "ratio",
    lab_low: 9.0,
    lab_high: 20.0
  },
  "Sodium": {
    units: "mmol/L",
    lab_low: 134.0,
    lab_high: 144.0
  },
  "Potassium": {
    units: "mmol/L",
    lab_low: 3.5,
    lab_high: 5.2
  },
  "Chloride": {
    units: "mmol/L",
    lab_low: 96.0,
    lab_high: 106.0
  },
  "Calcium": {
    units: "mg/dL",
    lab_low: 8.7,
    lab_high: 10.2
  },
  "Phosphorus": {
    units: "mg/dL",
    lab_low: 2.8,
    lab_high: 4.1
  },
  "Protein, Total": {
    units: "g/dL",
    lab_low: 6.0,
    lab_high: 8.5
  },
  "Albumin": {
    units: "g/dL",
    lab_low: 4.1,
    lab_high: 5.2
  },
  "Globulin, Total": {
    units: "g/dL",
    lab_low: 1.5,
    lab_high: 4.5
  },
  "A/G Ratio": {
    units: "ratio",
    lab_low: 1.2,
    lab_high: 2.2
  },
  "Bilirubin, Total": {
    units: "mg/dL",
    lab_low: 0.0,
    lab_high: 1.2
  },
  "Alkaline Phosphatase": {
    units: "IU/L",
    lab_low: 44.0,
    lab_high: 121.0
  },
  "LDH": {
    units: "IU/L",
    lab_low: 121.0,
    lab_high: 224.0
  },
  "AST (SGOT)": {
    units: "IU/L",
    lab_low: 0.0,
    lab_high: 40.0
  },
  "ALT (SGPT)": {
    units: "IU/L",
    lab_low: 0.0,
    lab_high: 44.0
  },
  "GGT": {
    units: "IU/L",
    lab_low: 0.0,
    lab_high: 65.0
  },
  "Iron": {
    units: "ug/dL",
    lab_low: 38.0,
    lab_high: 169.0
  },
  "Cholesterol, Total": {
    units: "mg/dL",
    lab_low: 100.0,
    lab_high: 199.0
  },
  "Triglycerides": {
    units: "mg/dL",
    lab_low: 0.0,
    lab_high: 149.0
  },
  "HDL Cholesterol": {
    units: "mg/dL",
    lab_low: 39.0,
    lab_high: null
  },
  "LDL Chol Calc (NIH)": {
    units: "mg/dL",
    lab_low: 0.0,
    lab_high: 99.0
  },
  "T. Chol/HDL Ratio": {
    units: "ratio",
    lab_low: 0.0,
    lab_high: 5.0
  },
  "Homocyst(e)ine": {
    units: "umol/L",
    lab_low: 0.0,
    lab_high: 14.5
  },
  "Prostate Specific Ag": {
    units: "ng/mL",
    lab_low: 0.0,
    lab_high: 4.0
  },
  "Free Testosterone(Direct)": {
    units: "pg/mL",
    lab_low: 9.3,
    lab_high: 26.5
  },
  "DHEA-Sulfate": {
    units: "ug/dL",
    lab_low: 138.5,
    lab_high: 475.2
  },
  "Estradiol": {
    units: "pg/mL",
    lab_low: 7.6,
    lab_high: 42.6
  },
  "C-Reactive Protein, Cardiac": {
    units: "mg/L",
    lab_low: 0.0,
    lab_high: 3.0
  },
  "WBC": {
    units: "x10E3/uL",
    lab_low: 3.4,
    lab_high: 10.8
  },
  "RBC": {
    units: "x10E6/uL",
    lab_low: 4.14,
    lab_high: 5.80
  },
  "Hemoglobin": {
    units: "g/dL",
    lab_low: 13.0,
    lab_high: 17.7
  },
  "Hematocrit": {
    units: "%",
    lab_low: 37.5,
    lab_high: 51.0
  },
  "MCV": {
    units: "fL",
    lab_low: 79.0,
    lab_high: 97.0
  },
  "MCH": {
    units: "pg",
    lab_low: 26.6,
    lab_high: 33.0
  },
  "MCHC": {
    units: "g/dL",
    lab_low: 31.5,
    lab_high: 35.7
  },
  "RDW": {
    units: "%",
    lab_low: 11.6,
    lab_high: 15.4
  },
  "Platelets": {
    units: "x10E3/uL",
    lab_low: 150.0,
    lab_high: 450.0
  },
  "Neutrophils (Absolute)": {
    units: "x10E3/uL",
    lab_low: 1.4,
    lab_high: 7.0
  },
  "Lymphs (Absolute)": {
    units: "x10E3/uL",
    lab_low: 0.7,
    lab_high: 3.1
  },
  "Monocytes(Absolute)": {
    units: "x10E3/uL",
    lab_low: 0.1,
    lab_high: 0.9
  },
  "Eos (Absolute)": {
    units: "x10E3/uL",
    lab_low: 0.0,
    lab_high: 0.4
  },
  "Baso (Absolute)": {
    units: "x10E3/uL",
    lab_low: 0.0,
    lab_high: 0.2
  },
  "Immature Grans (Abs)": {
    units: "x10E3/uL",
    lab_low: 0.0,
    lab_high: 0.1
  },
  "Hemoglobin A1c": {
    units: "%",
    lab_low: 4.8,
    lab_high: 5.6
  },
  "Testosterone": {
    units: "ng/dL",
    lab_low: 264.0,
    lab_high: 916.0
  },
  "TSH": {
    units: "uIU/mL",
    lab_low: 0.45,
    lab_high: 4.5
  },
  "T4 (free)": {
    units: "ng/dL",
    lab_low: 0.82,
    lab_high: 1.77
  },
  "T3 (free)": {
    units: "pg/mL",
    lab_low: 2.0,
    lab_high: 4.4
  },
  "Vitamin D, 25-Hydroxy": {
    units: "ng/mL",
    lab_low: 30.0,
    lab_high: 100.0
  },
  "Magnesium": {
    units: "mg/dL",
    lab_low: 1.6,
    lab_high: 2.3
  },
  "Insulin": {
    units: "uIU/mL",
    lab_low: 2.6,
    lab_high: 24.9
  },
  "Ferritin": {
    units: "ng/mL",
    lab_low: 30.0,
    lab_high: 400.0
  },
  "Apolipoprotein B": {
    units: "mg/dL",
    lab_low: null,
    lab_high: 90.0
  },
  "Thyroid Peroxidase (TPO) Ab": {
    units: "IU/mL",
    lab_low: 0,
    lab_high: 34
  },
  "Thyroglobulin Antibody": {
    units: "IU/mL",
    lab_low: 0,
    lab_high: 1.0
  },
  "Vitamin B12": {
    units: "pg/mL",
    lab_low: 300,
    lab_high: 900
  },
  "Folate": {
    units: "ng/mL",
    lab_low: 3.0,
    lab_high: 17.0
  },
  "Cortisol": {
    units: "mcg/dL",
    lab_low: 6.2,
    lab_high: 19.4
  },
  "TIBC": {
    units: "mcg/dL",
    lab_low: 250.0,
    lab_high: 425.0
  },
  "Iron Saturation": {
    units: "%",
    lab_low: 20.0,
    lab_high: 48.0
  },
  "Dihydrotestosterone": {
    units: "ng/dL",
    lab_low: 12.0,
    lab_high: 65.0
  },
  "Pregnenolone": {
    units: "ng/dL",
    lab_low: 22.0,
    lab_high: 237.0
  },
  "PSA (Free)": {
    units: "ng/mL",
    lab_low: null,
    lab_high: null
  },
  "PSA (% Free)": {
    units: "%",
    lab_low: 25.0,
    lab_high: null
  },
  "Reverse T3": {
    units: "ng/dL",
    lab_low: 8.0,
    lab_high: 25.0
  },
  "Estrogen (Total)": {
    units: "pg/mL",
    lab_low: 0.0,
    lab_high: 404.0
  },
  "Lymphocytes": {
    units: "%",
    lab_low: 14.0,
    lab_high: 46.0
  }
};

let labOverrides = {};

export function setLabDefaults(overrides) {
  labOverrides = overrides || {};
}

export const getTestNames = () => {
  const allKeys = new Set([...Object.keys(defaultTestData), ...Object.keys(labOverrides)]);
  return [...allKeys];
};

export const getTestData = (testName) => {
  if (!testName || typeof testName !== 'string') return undefined;
  const base = defaultTestData[testName];
  const override = labOverrides[testName];
  if (!base && !override) return undefined;
  return { ...base, ...override };
};

export const isRecognizedTest = (testName) => {
  if (!testName || typeof testName !== 'string') return false;
  return testName in defaultTestData || testName in labOverrides;
};
